<template>
  <div class="my-3">
    <div class="file-upload" @click="ClickBtn">
      <div class="file-upload__label"> {{"選擇檔案 Select file"}} </div>
      <div class="file-upload__content"> {{ fileName }} </div>
    </div>
    <input
      ref="El_FireInput"
      type="file"
      style="display: none;"
      @change="emitContent"
    >
    <!-- <CFormInput
      ref="El_FireInput"
      :disabled="+info.is_help" 
      type="file"
      @change="emitContent" class="mb-3"
    /> -->
    已上傳檔案 File Uploaded：
    <img style="max-width:600px" :src="fileUrl" />
    <MsgBox
      :show="showMsgBox"
      :errorMsg="errorMsg"
      @close="showMsgBox = false"
    />
  </div>
</template>
<script>
import useQuestionnaire from '@/composables/useQuestionnaire'
import { ref, watch, onMounted, computed } from '@vue/runtime-core'
import MsgBox from '@/components/MsgBox.vue'

export default {
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['content'],
  components: {
    MsgBox,
  },
  setup(props, { emit }) {
    const { uploadFile } = useQuestionnaire()
    const showMsgBox = ref(false)
    const errorMsg = ref('')
    const fileUrl = ref(null)
    const selectFileName = ref('');
    const El_FireInput = ref(null);
    const emitContent = async (e) => {
      if (e) {
        const formData = new FormData()
        formData.append('file', e?.target.files[0])
        selectFileName.value = e?.target.files[0]?.name || ''
        const res = await uploadFile(formData)
        if (!res.error) {
          emit('content', {
            part_item_id: props.info.part_item_id,
            value_info: res.ret.file || '',
            type: props.info.type,
          })
          fileUrl.value = res.ret.file
        } else {
          showMsgBox.value = true
          errorMsg.value = res.msg
        }
      } else {
        emit('content', {
          part_item_id: props.info.part_item_id,
          is_help: +props.info.is_help ? '1' : '0',
          help_message: props.info?.help_message ||'',
          is_finish: !!fileUrl.value,
          value_info: !+props.info.is_help ? fileUrl.value : null,
          type: props.info.type,
        })
      }
    }
    emitContent()
    const fileName = computed(() => {
      return selectFileName.value? selectFileName.value: '未選擇任何檔案 No file selected'
    });
    const ClickBtn = () => {
      if (!El_FireInput.value) return;
      El_FireInput.value.focus();
      El_FireInput.value.click();
    };
    onMounted(() => {
      emitContent()
    })
    watch(
      () => props.info.value_info,
      (newVal) => {
        fileUrl.value = newVal
        emitContent()
      },
      { immediate: true },
    )
    watch(
      () => props.info.is_help,
      () => {
        emitContent()
      },
    )
    return {
      El_FireInput,
      fileName,
      ClickBtn,
      emitContent,
      showMsgBox,
      errorMsg,
      fileUrl,
    }
  },
}
</script>

<style scoped>
.file-upload {
  border: 1px solid #d8dbe0;
  border-radius: 0.375rem;
  display: flex;
  align-items: center;
  user-select: none;
  cursor: pointer;
  transition: box-shadow .2s ease;
}
.file-upload:active {
  box-shadow: 0 0 0 0.25rem rgba(93, 163, 199, 0.25);
}

.file-upload__label {
  padding: 6px 12px;
  border-right: 1px solid #d8dbe0;
  background-color: #ecedef;
}
.file-upload__content {
  padding: 6px 12px;
}
</style>
